import {
    GET_CASE_HISTORY_REQUEST,
    GET_CASE_HISTORY_SUCCESS,
    GET_CASE_HISTORY_FAILURE
} from './constants';

export function getCaseHistory(caseId, pagination = {}) {
    return {
        type: GET_CASE_HISTORY_REQUEST,
        data: { caseId, pagination }
    }
}

export function getCaseHistorySuccess(response) {
    return {
        type: GET_CASE_HISTORY_SUCCESS,
        data: response
    }
}

export function getCaseHistoryFailure() {
    return {
        type: GET_CASE_HISTORY_FAILURE,
        data: {}
    }
}




// WEBPACK FOOTER //
// ./src/containers/History/actions.js